
import moment from "moment";
import _ from "lodash";
import { mapGetters } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { SistemaMixin } from "@/modules/Application";
import ChevronLeft from "vue-material-design-icons/ChevronLeft.vue";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";
import ClockOutline from "vue-material-design-icons/ClockOutline.vue";
import CalendarLock from "vue-material-design-icons/CalendarLock.vue";
import CalendarToday from "vue-material-design-icons/CalendarToday.vue";
import Cog from "vue-material-design-icons/Cog.vue";
import LinkVariant from "vue-material-design-icons/LinkVariant.vue";
import Magnify from "vue-material-design-icons/Magnify.vue";
import crmService from "../services/crmService";

const SLOT_MINUTES = 15;
const USER_COLORS = [
  "#3699ff",
  "#1bc5bd",
  "#ffa800",
  "#f64e60",
  "#8950fc",
  "#0bb783",
  "#e83e8c",
  "#3f4254",
];

export default {
  name: "app-crm-agendamento-agenda",
  mixins: [SistemaMixin],
  components: {
    VueSelect,
    ChevronLeft,
    ChevronRight,
    ClockOutline,
    CalendarLock,
    CalendarToday,
    Cog,
    LinkVariant,
    Magnify,
  },
  data() {
    return {
      usuario: null,
      usuarios: [],
      crmPermissao: null,
      selectedUserIds: [],
      loadedUserIds: [],
      clientes: [],
      data: moment().format("YYYY-MM-DD"),
      viewMode: "week",
      loadingHorarios: false,
      searchingNextAvailable: false,
      horariosError: "",
      horarios: {
        expediente: null,
        slots: [],
        ocupados: [],
        resumo: null,
      },
      weekHorarios: {},
      bloqueioForm: {
        data_inicio: "",
        data_fim: "",
        motivo: "",
      },
      configForm: {
        expedientes: {
          0: [],
          1: [{ inicio: "08:00", fim: "18:00" }],
          2: [{ inicio: "08:00", fim: "18:00" }],
          3: [{ inicio: "08:00", fim: "18:00" }],
          4: [{ inicio: "08:00", fim: "18:00" }],
          5: [{ inicio: "08:00", fim: "18:00" }],
          6: [{ inicio: "08:00", fim: "18:00" }],
        },
      },
      linkForm: {
        cliente: null,
        data_inicio: moment().format("YYYY-MM-DD"),
        data_fim: moment().format("YYYY-MM-DD"),
        duracao_minutos: 30,
      },
      linkGerado: "",
      diasSemana: [
        { key: "0", label: "Domingo" },
        { key: "1", label: "Segunda-feira" },
        { key: "2", label: "Terça-feira" },
        { key: "3", label: "Quarta-feira" },
        { key: "4", label: "Quinta-feira" },
        { key: "5", label: "Sexta-feira" },
        { key: "6", label: "Sábado" },
      ],
    };
  },
  computed: {
    ...mapGetters(["currentUser"]),
    currentUserAgendaUser() {
      return {
        id_usuario: this.currentUser?.id_usuario,
        nome: this.currentUser?.nome || this.currentUser?.usuario,
        usuario: this.currentUser?.usuario,
      };
    },
    canManageAgendaUsers() {
      const papeis = Array.isArray(this.crmPermissao?.papeis)
        ? this.crmPermissao.papeis
        : [];

      return (
        !!this.currentUser?.admin ||
        !!this.crmPermissao?.gestor ||
        papeis.includes("gestor")
      );
    },
    canSearchAgenda() {
      if (!this.canManageAgendaUsers) return true;
      if (this.viewMode === "week") return this.selectedUserIds.length > 0;
      return !!this.usuario?.id_usuario;
    },
    canShowAgenda() {
      if (this.canManageAgendaUsers && this.viewMode === "week") {
        return this.loadedUserIds.length > 0;
      }
      return this.canSearchAgenda;
    },
    visibleUsuarios() {
      if (!this.canManageAgendaUsers) {
        return [this.currentUserAgendaUser].filter((item) => item.id_usuario);
      }

      if (this.viewMode === "day") {
        return this.usuario?.id_usuario ? [this.usuario] : [];
      }

      return this.usuariosByIds(this.loadedUserIds);
    },
    hasPendingUserSelection() {
      if (!this.canManageAgendaUsers || this.viewMode !== "week") return false;

      return (
        this.normalizedUserIds(this.selectedUserIds).join(",") !==
        this.normalizedUserIds(this.loadedUserIds).join(",")
      );
    },
    todosUsuariosSelecionados() {
      if (!this.usuarios.length) return false;

      return (
        this.normalizedUserIds(this.selectedUserIds).length ===
        this.normalizedUserIds(
          this.usuarios.map((usuario) => usuario.id_usuario)
        ).length
      );
    },
    agendaTargetUser() {
      if (this.canManageAgendaUsers && this.usuario?.id_usuario) {
        return this.usuario;
      }

      return this.visibleUsuarios[0] || this.currentUserAgendaUser;
    },
    navigationStep() {
      return this.viewMode === "week" ? 7 : 1;
    },
    selectedDate() {
      return this.normalizeDate(this.data);
    },
    weekStartDate() {
      return moment(this.selectedDate).startOf("isoWeek");
    },
    weekEndDate() {
      return this.weekStartDate.clone().add(6, "days");
    },
    headerTitle() {
      if (this.viewMode === "week") {
        return `${this.weekStartDate.format(
          "DD/MM/YYYY"
        )} - ${this.weekEndDate.format("DD/MM/YYYY")}`;
      }

      return moment(this.data).format("dddd, DD/MM/YYYY");
    },
    summaryTitle() {
      return this.viewMode === "week" ? "Resumo da semana" : "Resumo do dia";
    },
    summaryDateLabel() {
      return this.viewMode === "week"
        ? this.headerTitle
        : moment(this.selectedDate).format("dddd, DD/MM/YYYY");
    },
    summaryUserLabel() {
      if (this.viewMode === "week" && this.canManageAgendaUsers) {
        return `${this.visibleUsuarios.length} selecionado(s)`;
      }

      return this.usuarioLabel(this.visibleUsuarios[0]);
    },
    busyListTitle() {
      return "Ocupados no dia";
    },
    totalSlotsCount() {
      if (this.viewMode === "week") {
        return this.weekDays.reduce((total, day) => {
          return total + this.weekDayHorarios(day.date).slots.length;
        }, 0);
      }

      return this.horarios.slots.length;
    },
    availableSlotsCount() {
      if (this.viewMode === "week") {
        return this.weekDays.reduce((total, day) => {
          const slots = this.weekDayHorarios(day.date).slots;
          return total + slots.filter((slot) => slot.disponivel).length;
        }, 0);
      }

      return this.horarios.slots.filter((slot) => slot.disponivel).length;
    },
    busySlotsCount() {
      return this.busyAppointments.length;
    },
    busyAppointments() {
      if (this.viewMode === "week") {
        return this.weekDays.flatMap((day) => {
          return this.weekDayHorarios(day.date).ocupados;
        });
      }

      return this.horarios.ocupados;
    },
    hasSlots() {
      return this.horarios.slots.length > 0;
    },
    hasWeekData() {
      return this.weekDays.some((day) => {
        const horarios = this.weekDayHorarios(day.date);
        return horarios.expediente || horarios.slots.length;
      });
    },
    hasAvailableSlots() {
      return this.availableSlotsCount > 0;
    },
    dailyDisplaySlots() {
      const firstSlotByAppointment = {};

      this.horarios.slots.forEach((slot) => {
        if (slot.disponivel || !slot.id_agendamento_ocupado) return;

        if (!firstSlotByAppointment[slot.id_agendamento_ocupado]) {
          firstSlotByAppointment[slot.id_agendamento_ocupado] = slot.inicio;
        }
      });

      return this.horarios.slots
        .map((slot) => {
          if (slot.disponivel) return slot;

          const ocupado = this.findOcupadoBySlot(slot, this.horarios.ocupados);

          if (!ocupado) return slot;

          const firstSlot =
            firstSlotByAppointment[ocupado.id_agendamento] || slot.inicio;

          if (!moment(slot.inicio).isSame(moment(firstSlot), "minute")) {
            return null;
          }

          return {
            ...slot,
            ocupado,
            inicio: ocupado.data_inicio,
            fim: ocupado.data_fim,
          };
        })
        .filter(Boolean);
    },
    slotGroups() {
      const groups = [
        { label: "Manhã", start: "00:00", end: "11:59", slots: [] },
        { label: "Tarde", start: "12:00", end: "16:59", slots: [] },
        { label: "Fim do dia", start: "17:00", end: "23:59", slots: [] },
      ];

      this.dailyDisplaySlots.forEach((slot) => {
        const hora = moment(slot.inicio).format("HH:mm");
        const group = groups.find(
          (item) => hora >= item.start && hora <= item.end
        );

        if (group) {
          group.slots.push(slot);
        }
      });

      return groups
        .filter((group) => group.slots.length)
        .map((group) => ({
          ...group,
          total: group.slots.length,
          available: group.slots.filter((slot) => slot.disponivel).length,
        }));
    },
    weekDays() {
      return Array.from({ length: 7 }, (_, index) => {
        const date = this.weekStartDate.clone().add(index, "days");

        return {
          date: date.format("YYYY-MM-DD"),
          label: date.format("ddd"),
          shortDate: date.format("DD/MM"),
        };
      });
    },
    weekTimeRows() {
      let minMinutes = null;
      let maxMinutes = null;
      const step = this.weekSlotMinutes;

      this.weekDays.forEach((day) => {
        const horarios = this.weekDayHorarios(day.date);
        const ranges = [
          ...horarios.slots.map((slot) => ({
            inicio: slot.inicio,
            fim: slot.fim,
          })),
          ...horarios.ocupados.map((ocupado) => ({
            inicio: ocupado.data_inicio,
            fim: ocupado.data_fim,
          })),
        ];

        ranges.forEach((range) => {
          if (!range.inicio || !range.fim) return;

          const start = this.timeToMinutes(
            moment(range.inicio).format("HH:mm")
          );
          const end = this.timeToMinutes(moment(range.fim).format("HH:mm"));

          minMinutes =
            minMinutes === null ? start : Math.min(minMinutes, start);
          maxMinutes = maxMinutes === null ? end : Math.max(maxMinutes, end);
        });
      });

      if (minMinutes === null || maxMinutes === null) return [];

      minMinutes = Math.floor(minMinutes / step) * step;
      maxMinutes = Math.ceil(maxMinutes / step) * step;

      const rows = [];

      for (let minutes = minMinutes; minutes < maxMinutes; minutes += step) {
        rows.push(this.minutesToTime(minutes));
      }

      return rows;
    },
    weekSlotMinutes() {
      let hasPreciseTime = false;

      this.weekDays.forEach((day) => {
        const horarios = this.weekDayHorarios(day.date);
        const ranges = [
          ...horarios.slots.map((slot) => ({
            inicio: slot.inicio,
            fim: slot.fim,
          })),
          ...horarios.ocupados.map((ocupado) => ({
            inicio: ocupado.data_inicio,
            fim: ocupado.data_fim,
          })),
        ];

        ranges.forEach((range) => {
          if (!range.inicio || !range.fim) return;

          const start = this.timeToMinutes(
            moment(range.inicio).format("HH:mm")
          );
          const end = this.timeToMinutes(moment(range.fim).format("HH:mm"));
          const duration = Math.max(end - start, 1);

          if (
            start % SLOT_MINUTES !== 0 ||
            end % SLOT_MINUTES !== 0 ||
            duration < SLOT_MINUTES
          ) {
            hasPreciseTime = true;
          }
        });
      });

      return hasPreciseTime ? 5 : SLOT_MINUTES;
    },
    weekRowHeight() {
      return this.weekSlotMinutes < SLOT_MINUTES ? 28 : 34;
    },
    weekGridStyle() {
      return {
        gridTemplateRows: `repeat(${this.weekTimeRows.length}, ${this.weekRowHeight}px)`,
      };
    },
    weekEvents() {
      return this.weekDays.flatMap((day, dayIndex) => {
        const horarios = this.weekDayHorarios(day.date);
        if (horarios.expediente?.fechado) return [];

        const events = horarios.ocupados
          .map((ocupado) => {
            const startIndex = this.timeToRowIndex(ocupado.data_inicio);
            const endIndex = this.timeToRowIndex(ocupado.data_fim, "ceil");
            const clampedStartIndex = Math.max(startIndex, 0);
            const clampedEndIndex = Math.min(
              endIndex,
              this.weekTimeRows.length
            );
            const span = Math.max(clampedEndIndex - clampedStartIndex, 1);

            if (
              endIndex <= 0 ||
              clampedStartIndex >= this.weekTimeRows.length
            ) {
              return null;
            }

            const isBlocked = this.isBloqueioOcupado(ocupado);

            return {
              key: `${day.date}-${ocupado.id_usuario}-${
                ocupado.id_agendamento || ocupado.id_agendamento_bloqueio
              }`,
              column: dayIndex + 2,
              row: `${clampedStartIndex + 1} / span ${span}`,
              rowStartIndex: clampedStartIndex,
              rowEndIndex: clampedEndIndex,
              time: `${this.formatTime(
                ocupado.data_inicio
              )} - ${this.formatTime(ocupado.data_fim)}`,
              shortTime: `${this.formatTime(
                ocupado.data_inicio
              )}-${this.formatTime(ocupado.data_fim)}`,
              cliente: isBlocked ? "Bloqueado" : ocupado.cliente || "Cliente",
              usuario:
                ocupado.usuario || this.usuarioLabel(ocupado.usuario_agenda),
              servico: isBlocked ? "" : this.ocupadoServico(ocupado),
              status: this.statusLabel(ocupado.status),
              color: isBlocked
                ? "#b5b5c3"
                : ocupado.cor_usuario || this.usuarioColor(ocupado),
              background: isBlocked
                ? "#f3f6f9"
                : this.usuarioBackground(ocupado),
              isBlocked,
              isShort: span === 1,
              title: isBlocked
                ? `Bloqueado
${this.formatTime(ocupado.data_inicio)} - ${this.formatTime(ocupado.data_fim)}
${ocupado.observacoes || ocupado.motivo || ""}`
                : `${ocupado.cliente || "Cliente"}
${this.formatTime(ocupado.data_inicio)} - ${this.formatTime(ocupado.data_fim)}
${ocupado.usuario || ""}
${this.ocupadoServico(ocupado)}
${this.statusLabel(ocupado.status)}`,
            };
          })
          .filter(Boolean);

        return this.assignEventLanes(events);
      });
    },
  },
  methods: {
    normalizedUserIds(ids = []) {
      return Array.from(
        new Set(
          ids
            .map((id) => Number(id))
            .filter((id) => Number.isInteger(id) && id > 0)
        )
      ).sort((a, b) => a - b);
    },
    usuariosByIds(ids = []) {
      const usuariosPorId = this.usuarios.reduce((carry, usuario) => {
        carry[Number(usuario.id_usuario)] = usuario;
        return carry;
      }, {});
      const currentId = Number(this.currentUserAgendaUser?.id_usuario || 0);

      return this.normalizedUserIds(ids)
        .map((id) => {
          if (usuariosPorId[id]) return usuariosPorId[id];
          if (id === currentId) return this.currentUserAgendaUser;
          return null;
        })
        .filter(Boolean);
    },
    defaultUserIds() {
      const idUsuario = Number(this.currentUserAgendaUser?.id_usuario || 0);
      return idUsuario ? [idUsuario] : [];
    },
    toggleTodosUsuariosAgenda() {
      if (this.todosUsuariosSelecionados) {
        this.selectedUserIds = this.defaultUserIds();
        return;
      }

      this.selectedUserIds = this.normalizedUserIds(
        this.usuarios.map((usuario) => usuario.id_usuario)
      );
    },
    ensureCurrentUserOption() {
      const idUsuario = Number(this.currentUserAgendaUser?.id_usuario || 0);

      if (!idUsuario) return;

      const exists = this.usuarios.some(
        (usuario) => Number(usuario.id_usuario) === idUsuario
      );

      if (!exists) {
        this.usuarios = [this.currentUserAgendaUser, ...this.usuarios];
      }
    },
    setUsuario(usuario) {
      this.usuario = usuario;
      this.loadAgenda();
    },
    setViewMode(mode) {
      if (this.viewMode === mode) return;
      this.viewMode = mode;
      this.loadAgenda();
    },
    changeDate() {
      this.loadAgenda();
    },
    moveDate(days) {
      this.data = moment(this.data).add(days, "days").format("YYYY-MM-DD");
      this.loadAgenda();
    },
    setToday() {
      this.data = moment().format("YYYY-MM-DD");
      this.loadAgenda();
    },
    normalizeDate(value) {
      const date = moment(value, ["YYYY-MM-DD", "DD/MM/YYYY"], true);

      return date.isValid()
        ? date.format("YYYY-MM-DD")
        : moment(value).format("YYYY-MM-DD");
    },
    blankHorarios() {
      return {
        expediente: null,
        slots: [],
        ocupados: [],
        resumo: null,
      };
    },
    applyHorariosResponse(data) {
      this.horarios = {
        expediente: data.expediente || null,
        slots: data.slots || [],
        ocupados: data.ocupados || [],
        resumo: data.resumo || null,
      };
    },
    applyWeekResponse(items) {
      this.weekHorarios = items.reduce((carry, item) => {
        if (!carry[item.date]) {
          carry[item.date] = this.blankHorarios();
        }

        const current = carry[item.date];
        current.expediente = current.expediente || item.data.expediente || null;
        current.slots = current.slots.concat(
          this.decorateSlots(item.data.slots || [], item.usuario)
        );
        current.ocupados = current.ocupados.concat(
          this.decorateOcupados(item.data.ocupados || [], item.usuario)
        );
        current.resumo = item.data.resumo || current.resumo;

        return carry;
      }, {});
    },
    async fetchHorarios(data, usuario = this.visibleUsuarios[0]) {
      const agendaUser = this.canManageAgendaUsers
        ? usuario
        : this.currentUserAgendaUser;

      const response = await this.$http.post("/agendamentos/horarios", {
        data,
        id_usuario: agendaUser?.id_usuario,
        duracao_minutos: SLOT_MINUTES,
      });

      return response.data;
    },
    async loadAgenda() {
      if (this.canManageAgendaUsers && this.viewMode === "week") {
        if (this.loadedUserIds.length === 0 && this.selectedUserIds.length) {
          this.loadedUserIds = this.normalizedUserIds(this.selectedUserIds);
        }

        if (this.loadedUserIds.length === 0 || !this.data) {
          this.horariosError = "";
          this.applyHorariosResponse(this.blankHorarios());
          this.weekHorarios = {};
          return;
        }
      } else if (!this.canSearchAgenda || !this.data) {
        this.horariosError = "";
        this.applyHorariosResponse(this.blankHorarios());
        this.weekHorarios = {};
        return;
      }

      if (this.viewMode === "week") {
        await this.loadSemana();
        return;
      }

      await this.loadHorarios();
    },
    async buscarAgendas() {
      if (this.canManageAgendaUsers && this.viewMode === "week") {
        this.loadedUserIds = this.normalizedUserIds(this.selectedUserIds);

        if (this.loadedUserIds.length === 0) {
          this.$toast.warning("Selecione pelo menos um usuário.");
          return;
        }
      }

      await this.loadAgenda();
    },
    async loadHorarios() {
      this.loadingHorarios = true;
      this.horariosError = "";
      try {
        const data = this.normalizeDate(this.data);
        this.data = data;
        const usuario = this.visibleUsuarios[0];
        const horarios = await this.fetchHorarios(data, usuario);
        this.applyHorariosResponse({
          ...horarios,
          slots: this.decorateSlots(horarios.slots || [], usuario),
          ocupados: this.decorateOcupados(horarios.ocupados || [], usuario),
        });
      } catch (error) {
        this.applyHorariosResponse(this.blankHorarios());
        this.horariosError =
          error?.response?.data?.msg ||
          error?.response?.data?.message ||
          "Não foi possível carregar a agenda.";
      } finally {
        this.loadingHorarios = false;
      }
    },
    async loadSemana() {
      this.loadingHorarios = true;
      this.horariosError = "";
      try {
        const data = this.normalizeDate(this.data);
        this.data = data;
        const usuarios = this.visibleUsuarios;

        if (usuarios.length === 0) {
          this.weekHorarios = {};
          return;
        }

        const responses = await Promise.all(
          this.weekDays.flatMap((day) => {
            return usuarios.map(async (usuario) => ({
              date: day.date,
              usuario,
              data: await this.fetchHorarios(day.date, usuario),
            }));
          })
        );
        this.applyWeekResponse(responses);
      } catch (error) {
        this.weekHorarios = {};
        this.horariosError =
          error?.response?.data?.msg ||
          error?.response?.data?.message ||
          "Não foi possível carregar a agenda semanal.";
      } finally {
        this.loadingHorarios = false;
      }
    },
    async goToNextAvailableDate() {
      if (!this.canSearchAgenda) {
        this.$toast.warning("Selecione o usuário.");
        return;
      }

      this.searchingNextAvailable = true;
      this.loadingHorarios = true;
      this.horariosError = "";

      try {
        const start = moment(this.data);

        for (let day = 1; day <= 30; day += 1) {
          const data = start.clone().add(day, "days").format("YYYY-MM-DD");
          const horarios = await this.fetchHorarios(
            data,
            this.visibleUsuarios[0]
          );
          const hasAvailable = (horarios.slots || []).some(
            (slot) => slot.disponivel
          );

          if (hasAvailable) {
            this.data = data;
            if (this.viewMode === "week") {
              await this.loadSemana();
            } else {
              this.applyHorariosResponse(horarios);
            }
            return;
          }
        }

        this.horariosError =
          "Não encontrei horários livres nos próximos 30 dias.";
      } catch (error) {
        this.horariosError =
          error?.response?.data?.msg ||
          error?.response?.data?.message ||
          "Não foi possível buscar o próximo horário disponível.";
      } finally {
        this.loadingHorarios = false;
        this.searchingNextAvailable = false;
      }
    },
    weekDayHorarios(date) {
      return this.weekHorarios[date] || this.blankHorarios();
    },
    isWeekDayClosed(date) {
      const horarios = this.weekDayHorarios(date);
      return (
        !!horarios.expediente?.fechado &&
        horarios.slots.length === 0 &&
        horarios.ocupados.length === 0
      );
    },
    weekCellClass(date, time) {
      return {
        closed: this.isWeekCellClosed(date, time),
        blocked: this.isWeekCellBlocked(date, time),
        selected: date === this.selectedDate,
      };
    },
    isWeekCellClosed(date, time) {
      if (this.isWeekDayClosed(date)) return true;

      return this.slotsForWeekCell(date, time).length === 0;
    },
    isWeekCellBlocked(date, time) {
      if (this.isWeekCellClosed(date, time)) return false;

      const slots = this.slotsForWeekCell(date, time);

      if (!slots.length) return false;

      const hasAvailable = slots.some((slot) => slot.disponivel);
      const hasBlocked = slots.some((slot) => this.isBloqueioSlot(slot));

      return hasBlocked && !hasAvailable;
    },
    slotsForWeekCell(date, time) {
      const horarios = this.weekDayHorarios(date);
      const start = moment(`${date} ${time}`, "YYYY-MM-DD HH:mm");
      const end = start.clone().add(this.weekSlotMinutes, "minutes");

      return horarios.slots.filter((slot) => {
        return (
          moment(slot.inicio).isBefore(end) && moment(slot.fim).isAfter(start)
        );
      });
    },
    assignEventLanes(events) {
      const sortedEvents = [...events].sort((a, b) => {
        if (a.rowStartIndex !== b.rowStartIndex) {
          return a.rowStartIndex - b.rowStartIndex;
        }

        return a.rowEndIndex - b.rowEndIndex;
      });

      const clusters = [];
      let currentCluster = [];
      let currentClusterEnd = null;

      sortedEvents.forEach((event) => {
        if (
          currentCluster.length === 0 ||
          event.rowStartIndex < currentClusterEnd
        ) {
          currentCluster.push(event);
          currentClusterEnd =
            currentClusterEnd === null
              ? event.rowEndIndex
              : Math.max(currentClusterEnd, event.rowEndIndex);
          return;
        }

        clusters.push(currentCluster);
        currentCluster = [event];
        currentClusterEnd = event.rowEndIndex;
      });

      if (currentCluster.length) {
        clusters.push(currentCluster);
      }

      return clusters.flatMap((cluster) => {
        const lanes = [];
        const assigned = cluster.map((event) => {
          let laneIndex = lanes.findIndex(
            (laneEnd) => laneEnd <= event.rowStartIndex
          );

          if (laneIndex === -1) {
            laneIndex = lanes.length;
            lanes.push(event.rowEndIndex);
          } else {
            lanes[laneIndex] = event.rowEndIndex;
          }

          return {
            ...event,
            laneIndex,
          };
        });

        const laneCount = Math.max(lanes.length, 1);

        return assigned.map((event) => ({
          ...event,
          laneCount,
        }));
      });
    },
    decorateSlots(slots, usuario) {
      return slots.map((slot) => ({
        ...slot,
        id_usuario_agenda: usuario?.id_usuario,
        usuario_agenda: usuario,
      }));
    },
    decorateOcupados(ocupados, usuario) {
      return ocupados.map((ocupado) => ({
        ...ocupado,
        id_usuario: ocupado.id_usuario || usuario?.id_usuario,
        usuario: ocupado.usuario || this.usuarioLabel(usuario),
        usuario_agenda: usuario,
        cor_usuario: this.usuarioColor(usuario || ocupado),
      }));
    },
    usuarioLabel(usuario) {
      return usuario?.nome || usuario?.usuario || "-";
    },
    usuarioColor(usuario) {
      const id = Number(usuario?.id_usuario || 0);
      const index = id
        ? id % USER_COLORS.length
        : Math.abs(this.usuarioLabel(usuario).length) % USER_COLORS.length;

      return USER_COLORS[index];
    },
    usuarioBackground(usuario) {
      const color = this.usuarioColor(usuario);
      return `${color}18`;
    },
    timeToMinutes(time) {
      const [hours, minutes] = String(time)
        .split(":")
        .map((value) => Number(value));

      return hours * 60 + minutes;
    },
    minutesToTime(totalMinutes) {
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0"
      )}`;
    },
    timeToRowIndex(value, rounding = "floor") {
      if (!this.weekTimeRows.length) return -1;

      const firstRowMinutes = this.timeToMinutes(this.weekTimeRows[0]);
      const valueMinutes = this.timeToMinutes(moment(value).format("HH:mm"));
      const rowValue = (valueMinutes - firstRowMinutes) / this.weekSlotMinutes;

      return rounding === "ceil" ? Math.ceil(rowValue) : Math.floor(rowValue);
    },
    isBloqueioSlot(slot) {
      return (
        !!slot.id_bloqueio_ocupado ||
        slot.status === "bloqueio" ||
        String(slot.motivo || "")
          .toLowerCase()
          .includes("bloque")
      );
    },
    isBloqueioOcupado(ocupado) {
      return (
        ocupado?.tipo === "bloqueio" ||
        !!ocupado?.id_agendamento_bloqueio ||
        ocupado?.status === "bloqueio"
      );
    },
    slotLabel(slot) {
      const inicio = moment(slot.inicio).format("HH:mm");
      const fim = slot.fim ? moment(slot.fim).format("HH:mm") : "";

      return fim ? `${inicio} - ${fim}` : inicio;
    },
    slotStatusLabel(slot) {
      if (this.isBloqueioSlot(slot)) return "Bloqueado";
      if (slot.ocupado) return this.statusLabel(slot.ocupado.status);
      return slot.disponivel ? "Livre" : "Horário ocupado";
    },
    slotTitle(slot) {
      if (slot.disponivel) return "Horário livre";
      if (this.isBloqueioSlot(slot)) return "Bloqueado";

      const ocupado = slot.ocupado || this.findOcupadoBySlot(slot);
      const cliente = ocupado?.cliente || "Cliente";
      const servico = ocupado ? this.ocupadoServico(ocupado) : "Agendamento";

      return `${cliente} - ${servico}`;
    },
    findOcupadoBySlot(slot, ocupados = this.horarios.ocupados) {
      if (slot.id_agendamento_ocupado) {
        const ocupado = ocupados.find(
          (item) => item.id_agendamento === slot.id_agendamento_ocupado
        );

        if (ocupado) return ocupado;
      }

      return ocupados.find((item) => {
        return (
          moment(item.data_inicio).isBefore(moment(slot.fim)) &&
          moment(item.data_fim).isAfter(moment(slot.inicio))
        );
      });
    },
    ocupadoServico(ocupado) {
      return (
        ocupado.servico ||
        ocupado.descricao_servico ||
        ocupado.titulo ||
        "Agendamento"
      );
    },
    statusLabel(status) {
      const labels = {
        pendente: "Pendente",
        agendado: "Agendado",
        confirmado: "Confirmado",
        em_atendimento: "Em atendimento",
        concluido: "Concluido",
        cancelado: "Cancelado",
        nao_compareceu: "Nao compareceu",
      };

      return labels[status] || "Horario ocupado";
    },
    formatTime(value) {
      return value ? moment(value).format("HH:mm") : "--:--";
    },
    onSearchUsuario(search, loading) {
      if (search.length) {
        loading(true);
        this.searchUsuario(loading, search, this);
      }
    },
    searchUsuario: _.debounce(async (loading, search, vm) => {
      await vm.loadUsuarios(search);
      loading(false);
    }, 350),
    async loadCrmPermissao() {
      if (this.currentUser?.admin) {
        this.crmPermissao = { gestor: true, papeis: ["gestor"] };
        return;
      }

      try {
        const response = await crmService.permissaoAtribuicoesConfiguracao();
        const body = response?.data || {};
        this.crmPermissao = body.data || body || null;
      } catch (error) {
        this.crmPermissao = null;
      }
    },
    async loadUsuarios(search = "") {
      if (!this.canManageAgendaUsers) {
        this.usuario = this.currentUserAgendaUser;
        return;
      }

      const { data } = await this.$http.post("/usuario/get-usuarios", {
        search,
      });
      this.usuarios = Array.isArray(data) ? data : data.data || [];
      this.ensureCurrentUserOption();

      if (!this.usuario && this.usuarios.length) {
        const [idUsuarioPadrao] = this.defaultUserIds();
        this.usuario =
          this.usuarios.find(
            (usuario) => Number(usuario.id_usuario) === idUsuarioPadrao
          ) || this.usuarios[0];
      }

      if (this.selectedUserIds.length === 0) {
        this.selectedUserIds = this.defaultUserIds();
      }

      if (this.loadedUserIds.length === 0) {
        this.loadedUserIds = this.normalizedUserIds(this.selectedUserIds);
      }
    },
    openBloqueioModal() {
      const baseDate = this.selectedDate;
      this.bloqueioForm = {
        data_inicio: `${baseDate}T08:00`,
        data_fim: `${baseDate}T09:00`,
        motivo: "",
      };
      this.$bvModal.show("agendaBloqueioModal");
    },
    async salvarBloqueio(event) {
      event.preventDefault();

      if (!this.bloqueioForm.motivo || this.bloqueioForm.motivo.length < 3) {
        this.$toast.warning("Informe o motivo do bloqueio.");
        return;
      }

      await this.$http.post("/agendamentos/bloqueios", {
        id_usuario: this.agendaTargetUser?.id_usuario,
        data_inicio: this.datetimeLocalToApi(this.bloqueioForm.data_inicio),
        data_fim: this.datetimeLocalToApi(this.bloqueioForm.data_fim),
        motivo: this.bloqueioForm.motivo,
      });

      this.$bvModal.hide("agendaBloqueioModal");
      this.$toast.success("Agenda bloqueada!");
      this.loadAgenda();
    },
    async openConfiguracaoModal() {
      const { data } = await this.$http.post("/agendamentos/configuracao", {
        id_usuario: this.agendaTargetUser?.id_usuario,
      });

      const configuracao = data.data || data;
      this.configForm = {
        expedientes: this.ensureExpedientes(configuracao.expedientes),
      };
      this.$bvModal.show("agendaConfiguracaoModal");
    },
    async salvarConfiguracao(event) {
      event.preventDefault();

      await this.$http.post("/agendamentos/configuracao/salvar", {
        id_usuario: this.agendaTargetUser?.id_usuario,
        expedientes: this.configForm.expedientes,
      });

      this.$bvModal.hide("agendaConfiguracaoModal");
      this.$toast.success("Configuração salva!");
      this.loadAgenda();
    },
    ensureExpedientes(expedientes = {}) {
      return this.diasSemana.reduce((carry, dia) => {
        carry[dia.key] = (expedientes[dia.key] || []).map((bloco) => ({
          inicio: bloco.inicio,
          fim: bloco.fim,
        }));

        return carry;
      }, {});
    },
    addExpedienteBloco(dia) {
      this.configForm.expedientes[dia].push({
        inicio: "08:00",
        fim: "18:00",
      });
    },
    removeExpedienteBloco(dia, index) {
      this.configForm.expedientes[dia].splice(index, 1);
    },
    openLinkModal() {
      this.linkGerado = "";
      this.linkForm = {
        cliente: null,
        data_inicio: this.selectedDate,
        data_fim: this.selectedDate,
        duracao_minutos: 30,
      };
      this.$bvModal.show("agendaLinkModal");
    },
    async gerarLinkAgenda(event) {
      event.preventDefault();

      const duracao = Number(this.linkForm.duracao_minutos || 0);

      if (!this.linkForm.data_inicio || !this.linkForm.data_fim) {
        this.$toast.warning("Informe o período do link.");
        return;
      }

      if (this.linkForm.data_inicio > this.linkForm.data_fim) {
        this.$toast.warning(
          "A data final deve ser igual ou posterior à inicial."
        );
        return;
      }

      if (!Number.isInteger(duracao) || duracao < 1 || duracao > 1440) {
        this.$toast.warning("Informe uma duração entre 1 minuto e 24 horas.");
        return;
      }

      const { data } = await this.$http.post("/agendamentos/link", {
        id_usuario: this.agendaTargetUser?.id_usuario,
        id_pessoa: this.linkForm.cliente?.id_pessoa || null,
        origem: "crm_agenda",
        duracao_minutos: duracao,
        data_inicio: `${this.linkForm.data_inicio} 00:00:00`,
        data_fim: `${this.linkForm.data_fim} 23:59:59`,
      });

      this.linkGerado = data.data?.url_publica || data.url_publica;
      this.$toast.success("Link gerado!");
    },
    onSearchCliente(search, loading) {
      if (search.length) {
        loading(true);
        this.searchCliente(loading, search, this);
      }
    },
    searchCliente: _.debounce(async (loading, search, vm) => {
      vm.clientes = await vm.getClientes(search);
      loading(false);
    }, 350),
    async handleInitialAction() {
      const acao = this.$route.query.acao;

      if (acao === "bloqueio") {
        this.openBloqueioModal();
      }

      if (acao === "configuracao") {
        await this.openConfiguracaoModal();
      }

      if (acao === "link") {
        this.openLinkModal();
      }
    },
    datetimeLocalToApi(value) {
      return moment(value).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  async created() {
    moment.locale("pt-br");
    this.$store.dispatch("setLoading", false);
    await this.loadCrmPermissao();
    await this.loadUsuarios();
    await this.loadAgenda();
    await this.handleInitialAction();
  },
  beforeDestroy() {
    this.$store.dispatch("setLoading", false);
  },
};
